<template>
  <!-- style="height: 0px; overflow: hidden;" -->
  <div style="height: 0px; overflow: hidden;">
    <div class="pdf-row" id="pdfTest">
      <div class="top">用车申请审批单</div>
      <barcode 
        class="barcode" 
        :value="info.eventId" 
        width="1" 
        height="30" 
        background="transparent"
        :displayValue="true"
        fontSize="14"
      ></barcode>
      <div class="date">申请日期：{{this.info.createTime}}</div>
      <el-row class="table-row">
        <el-col :span="4" class="">申请编号</el-col>
        <el-col :span="20" class="border-left">{{this.info.eventId || '-'}}</el-col>
        <el-col :span="4" class="border-top">车牌号</el-col>
        <el-col :span="20" class="border-left border-top ">{{this.info.carNo || '-'}}</el-col>
        <el-col :span="12" class="border-top">品牌：{{this.info.brand}}</el-col>
        <el-col :span="12" class="border-left border-top  ">使用周期：{{this.info.begin}} - {{ this.info.end }}</el-col>
        <el-col :span="12" class="border-top">使用里程：{{this.info.distance}}</el-col>
        <el-col :span="12" class="border-left border-top ">驾驶员：{{this.info.driver}}</el-col>
        <el-col :span="12" class="border-top">驾驶员联系方式：{{this.info.driverTel}}</el-col>
        <el-col :span="12" class="border-left border-top ">是否出省：{{this.info.needLeaveProvince}}</el-col>
        <el-col :span="24" class="border-top ">申请原因： {{this.info.applyReason}}</el-col>
        <el-col :span="4"  class="amount border-top"><div>所属公司</div></el-col>
        <el-col :span="20" class="amount-value border-left border-top">{{this.info.companyName}}</el-col>
        <el-col :span="4" class="amount border-top"><div>申请部门</div></el-col>
        <el-col :span="8" class="amount-value border-left border-top">{{this.info.deptName}}</el-col>
        <el-col :span="4" class="amount border-left border-top"><div>经办人</div></el-col>
        <el-col :span="8" class="amount-value border-left border-top ">{{this.info.applyUser}}</el-col>

        <el-col v-for="(item,index) in auditProcessEntityList" :key="index" class="border-top "  style="padding:0; display: flex;">
          <!-- :style="{height: approvalHeight + 'px', padding:0}"  -->
          <el-col :span="12" ref="approvalLeft"  style="padding:0;display: flex;align-items: center;">
            <el-col :span="8" class="amount" style="padding:0"><div>{{(item.status == 20 || item.status == 21) ? '提交人：' : '审核人：'}}</div></el-col>
            <el-col :span="16" class="amount-value border-left" style="display: flex;align-items: center;height:100%"> {{item.auditPerson}}</el-col>
          </el-col>
          <el-col :span="12" class="border-left" ref="approvalRight"  style="padding:0;display: flex;align-items: center;padding:0">
            <el-col :span="8" class="amount" v-if="!([20, 21].includes(item.status))"><div>审核意见/时间：</div></el-col>
            <el-col :span="16" class="border-left" v-if="!([20, 21].includes(item.status))">
                <div> 时间：{{item.createTime}}</div>
                <div style="word-break:break-word"> 意见：{{item.remark }}</div>
            </el-col>
            <el-col :span="8" class="amount" v-if="[20, 21].includes(item.status)"><div>提交时间：</div></el-col>
            <el-col :span="16" class="border-left" v-if="[20, 21].includes(item.status)">
                <div> 时间：{{item.createTime}}</div>
            </el-col>
          </el-col>
        </el-col>
        <!-- <el-col :span="4" class="amount border-left border-top">
          <div>部门主管</div>
          <div>意   见</div>
        </el-col>
        <el-col :span="8" class="amount-value border-left border-top"><pre> </pre></el-col>
        <el-col :span="4" class="amount border-left border-top">
          <div>行政办</div>
          <div>意  见</div>
        </el-col>
        <el-col :span="8" class="amount-value border-left border-top "><pre> </pre></el-col>
        <el-col :span="4" class="amount border-left border-top">
          <div>分管领导</div>
          <div>意   见</div>
        </el-col>
        <el-col :span="8" class="amount-value border-left border-top"><pre> </pre></el-col>
        <el-col :span="4" class="amount border-left border-top">
          <div>财务部</div>
          <div>意  见</div>
        </el-col>
        <el-col :span="8" class="amount-value border-left border-top "><pre> </pre></el-col>
        <el-col :span="4" class="amount border-left border-top">
          <div>主要领导</div>
          <div>意   见</div>
        </el-col> -->
        <!-- <el-col :span="20" class="amount-value border-left border-top "><pre> </pre></el-col> -->
        <el-col :span="24" class="border-top" style="height: 100px">备注：</el-col>
      </el-row>
      <div style="font-size: 16px; padding: 20px 50px;">会议纪要编号由行政办填写，请示报告填写编号</div>
    </div>
  </div>
</template>
<script>
import { htmlToPdf } from '@/utils/util'
import { getApplyDetail } from '@/api/carInfo'
export default {
  data () {
    return {
      checked: true,
      info: {
        carNo: '',
        brand: '',
        begin: '', // 使用开始时间开始日期时间
        end: '', // 使用开始时间结束日期时间
        distance: '', // 公里数
        driver: '',
        driverTel: '',
        needLeaveProvince: '',
        eventId: '',
        applyReason: '',
        remark: '',
        applyUser: '',
        deptName: '',
        companyName: '',
        createTime: '',
        payedTotal: '',
        payedThisTime: '',
        payedLeft: '',
        bankAccount: '',
        bank: '',
        roleName: ''
      },
      approvalHeight: 0,
      auditProcessEntityList: [
        {
          auditPerson: '姜旭',
          createTime: '2022-09-10'
        }
      ],
    }
  },
  mounted() {
  },
  methods: {
    async getDetails (id) {
      const res = await getApplyDetail({ id })
      const { code, result } = res
      if (code !== 0) return
      console.log(res);
      this.info = {
        createTime: result.createTime,
        eventId: result.eventId,
        carNo: result.carNo,
        brand: result.brand,
        begin: result.begin,
        end: result.end,
        distance: result.distance,
        driver: result.driver,
        driverTel: result.driverTel,
        needLeaveProvince: result.needLeaveProvince ? '是' : '否',
        applyReason: result.applyReason,
        applyUser: result.applyUser,
        payedTotal: result.payedTotal,
        payedThisTime: result.payedThisTime,
        payedLeft: result.payedLeft,
        roleName: result?.applyUserInfo?.roleName || '-',
        deptName: result?.deptName || '-',
        companyName: result?.companyInfoEntity?.companyName || '-',
      }
      this.auditProcessEntityList = result.auditProcessEntityList
      if (result.contractRelFlag === 0) {
        this.checked = false
      }
      this.approvalHeight = this.$refs.approvalRight[0].$el.clientHeight
      if (result.contractRelFlag === 1) {
        this.checked = true
      }
     setTimeout(() => {
      this.$nextTick(() => {
        htmlToPdf('#pdfTest', '用车申请审批单')
      })
     }, 1000);
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
.pdf-row {
  width: 1050px;
  padding: 40px 20px;
  padding-left: 60px;
  padding-right: 60px;
  padding-top: 100px;
  box-sizing: border-box;
  font-weight: bold;
  position: relative;
  .top {
    height: 100px;
    text-align: center;
    font-size: 25px;
    line-height: 100px;
    font-weight: bold;
    background-image: url('~@/assets/images/gateway/logo.jpg');
    background-repeat: no-repeat;
    background-size: 100px 100px;
  }
  .barcode{
      position: absolute;
      right: 55px;
      top: 40px;
      bottom: 0;
    }
  .date {
    text-align: right;
    font-size: 20px;
  }
  .table-row {
    border: 1px solid #000;
    /deep/ .el-col {
      padding: 0px 10px;
      box-sizing: border-box;
      line-height: 45px;
      font-size: 16px;
    }
    .amount {
      text-align: center;
      // align-items: center;
      // line-height: normal;
      display: flex;
      flex-wrap:wrap;
      align-items: center;
      // min-height: 86px;
      box-sizing: border-box;
      // padding: 20px 0;
      div {
        width: 100%;
      }
    }
    .amount-value {
      // line-height: 40px;
      font-weight: bold;
      // padding: 20px 0;
    }
    .border-left {
      border-left: 1px solid #000;
    }
    .border-top {
      border-top: 1px solid #000;
    }
    .border-right {
      border-right  : 1px solid #000;
    }
    .border-bottom {
      border-bottom: 1px solid #000;
    }
  }
}
</style>